import api from '@/api/openQuestion'

const state = {

}

const actions = {
  getQuestionTemplateGroupList (context, params) {
    return api.getQuestionTemplateGroupList(params)
  },
  createQuestionTemplateGroup (context, group) {
    return api.createQuestionTemplateGroup(group)
  },
  updateQuestionTemplateGroup (context, { questionId, data }) {
    return api.updateQuestionTemplateGroup(questionId, data)
  },
  createQuestionTemplate (context, question) {
    return api.createQuestionTemplate(question)
  },
  updateQuestionTemplate (context, { questionId, data }) {
    return api.updateQuestionTemplate(questionId, data)
  },
  moveGroupQuestionTemplate (context, { fromGroup, toGroup, question, moveTo }) {
    return api.moveGroupQuestionTemplate(fromGroup, toGroup, question, moveTo)
  },
  getDefaultQuestionTemplate (context, params) {
    return api.getDefaultQuestionTemplate(params)
  },
  getQuestionUpdateTaskList (context, params) {
    return api.getQuestionUpdateTaskList(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
